<script>
import Avatar from 'vue-avatar'
import lozad from 'lozad'
export default {
  name: 'AvatarWrapper',
  components: {
    Avatar
  },
  props: {
    userName: {
      type: String,
      default: ''
    },
    imageKey: {
      type: String,
      default: null
    },
    size: {
      type: Number,
      default: 100
    },
    format: {
      type: String,
      default: 'initials'
    },
    source: {
      type: String,
      default: null
    },
    fallback: {
      type: String,
      default: null
    },
    rounded: {
      type: Boolean,
      default: false
    },
    lighten: {
      type: Number,
      default: 50
    },
    isButton: {
      type: Boolean,
      default: false
    },
    styles: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String,
      default: 'hsla(0,0%,100%,1)'
    }
  },
  data () {
    return {
      bitmapTypes: ['PNG', 'JPG', 'JPEG', 'GIF', 'WEBP', 'AVIF']
    }
  },
  computed: {
    appliedStyles () {
      const defaultStyle = `backgroundColor: ${this.backgroundColor};`
      return this.styles ? this.styles : defaultStyle
    },
    displaySize () {
      return this.size
    },
    isInitials () {
      return (this.format.toLowerCase() !== 'svg') && !this.isBitmap
    },
    isBitmap () {
      return this.bitmapTypes.includes(this.format.toUpperCase())
    },
    isSVG () {
      return (this.format.toUpperCase() === 'SVG')
    },
    constraintStyles () {
      return `object-fit: contain; width: ${this.displaySize}px; height: ${this.displaySize}px; max-width: ${this.displaySize}px; max-height: ${this.displaySize}px;`
    },
    // constraintStyles () {
    //   return `object-fit: contain; width: ${this.displaySize}px; height: ${this.displaySize}px; max-width: ${this.displaySize}px; max-height: ${this.displaySize}px;`
    // },
    mediaValue () {
      // these are the media query breakpoints as designated in main.src for $mq
      //   mobile: 768,
      //   tablet: 1025,
      //   desktop: 1217,
      //   widescreen: 1409,
      //   fullhd: Infinity
      let mediaString = ''
      switch (this.$mq) {
        case 'mobile':
          mediaString = '(max-width: 768px)'
          break
        case 'tablet':
          mediaString = '(max-width: 1025px)'
          break
        case 'desktop':
          mediaString = '(min-width: 1026px)'
          break
        case 'widescreen':
          mediaString = '(min-width: 1026px)'
          break
        case 'fullhd':
          mediaString = '(min-width: 1026px)'
          break
        default:
      }
      return mediaString
    }
  },
  mounted () {
    const observer = lozad(this.$refs.lazyPic)
    observer.observe()
  }
}
</script>

<template>
  <div>
<!--    <p style="color: white;">-->
<!--      {{ appliedStyles }}-->
<!--    </p>-->
    <template v-if="isInitials">
      <avatar
        :username="userName"
        :size="displaySize"
        :rounded="rounded"
        :lighten="50"
      />
    </template>
    <template v-else>
      <div
        class="avatar-wrapper"
        :class="{'is-bitmap': isBitmap, 'is-svg': isSVG}"
        :style="appliedStyles"
      >
        <template v-if="isSVG">
          <img alt="avatar" :src="source" :width="displaySize" :height="displaySize" />
        </template>
        <template v-if="isBitmap">
          <div :style="constraintStyles">
            <picture
              ref="lazyPic"
              class="lozad"
              :style="constraintStyles"
              data-alt="user avatar"
            >
              <source
                :style="constraintStyles"
                :srcset="source"
                :media="mediaValue"
              />
              <img
                :style="constraintStyles"
                v-if="fallback"
                :src="fallback" alt="user avatar"
              />
            </picture>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<style lang="scss" scoped>
.avatar-wrapper {
  &.is-bitmap {
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    outline: 1px solid $gray-lighter;
    background-color: $white;
  }
  &.is-svg {
    align-items: center;
    justify-content: center;
    padding: 1rem;
    outline: 1px solid $gray-lighter;
    background-color: $white;
  }
}
</style>
